// SLICK MEDIA - 31-01-2025 - JB
// THIS SCRIPT HAS BEEN CODED FOR ALESSANDRA, DO NOT DELETE

// Check if the URL contains '/collections/'
if (window.location.pathname.includes('/collections/')) {
    // Proceed with the rest of the script
    const urlParams = new URLSearchParams(window.location.search);

    // Apply the 'availability' filter if it's not already set
    if (urlParams.get('filter.v.availability') !== '1') {
        urlParams.set('filter.v.availability', '1');
        const newUrl = window.location.origin + window.location.pathname + '?' + urlParams.toString();
        window.location.href = newUrl;
    }
}